if (!customElements.get('before-after-slider')) {
  customElements.define(
    'before-after-slider',
    class BeforeAfterSlider extends HTMLElement {
      constructor() {
        super();

        this.sliderInstance = false;
        this.layout = this.dataset.layout;
        this.items = Number(this.dataset.items);

        if (this.classList.contains('slideshow-height--adapt')) {
          this.calcSlideHeight();
        }

        this.initSlider();
      }

      static get observedAttributes() {
        return ['selected-index'];
      }

      get selectedIndex() {
        return parseInt(this.getAttribute('selected-index')) || 0;
      }

      set selectedIndex(index) {
        this.setAttribute('selected-index', `${index}`);
      }

      initSlider() {
        const additionModules = [FoxTheme.Swiper.Autoplay, FoxTheme.Swiper.Navigation];

        this.sliderOptions = {
          slidesPerView: 1.5,
          spaceBetween: 14.5,
          loop: true,
          grabCursor: true,
          allowTouchMove: true,
          threshold: 2,
          effect: 'slide',
          slidesPerGroup: 1,
          breakpoints: {
            640: {
              slidesPerView: 1.5,
              spaceBetween: 14.5,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
          },
          on: {
            init: this.handleAfterInit.bind(this),
          },
        };

        const prevButton = this.querySelector('.swiper-button-prev');
        const nextButton = this.querySelector('.swiper-button-next');

        if (prevButton && nextButton) {
          this.sliderOptions.navigation = {
            prevEl: prevButton,
            nextEl: nextButton,
          };
        }

        switch (this.layout) {
          default:
            // For standard layout, disable loop if we have 4 or fewer items
            if (this.items <= 4) {
              this.sliderOptions.loop = false;
              this.classList.remove('slideshow-controls-visible--yes');
            }
            break;
        }

        const autoplayDelay = parseInt(this.dataset.autoplay);
        if (autoplayDelay > 0) {
          this.sliderOptions = {
            ...this.sliderOptions,
            autoplay: {
              delay: autoplayDelay,
              disableOnInteraction: false,
            },
          };
        }

        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions, additionModules);
        this.sliderInstance.init();

        this.sliderInstance.slider.on('realIndexChange', this.handleSlideChange.bind(this));

        if (this.sliderInstance) {
          if (this.layout === 'centered' && !FoxTheme.config.mqlMobile) {
            const motionTextElements = Array.from(this.querySelectorAll('motion-element[data-text]'));
            motionTextElements &&
              motionTextElements.forEach((motionTextElement) => {
                if (
                  typeof motionTextElement.resetAnimation === 'function' &&
                  !motionTextElement.closest('.swiper-slide-active')
                ) {
                  motionTextElement.resetAnimation();
                }
              });
          }
          this.selectedElement = this.sliderInstance.slider.slides[this.sliderInstance.slider.activeIndex];
          if (this.selectedElement) {
            this.onReady(this.selectedElement);
          }
          // Fix accessibility
          const focusableElements = FoxTheme.a11y.getFocusableElements(this);
          const useLoop = this.sliderOptions.loop;

          focusableElements.forEach((element) => {
            element.addEventListener('focusin', () => {
              const slide = element.closest('.swiper-slide');

              if (!slide) return;

              const slideIndex = parseInt(slide.getAttribute('data-swiper-slide-index')) || 0;

              if (useLoop) {
                this.sliderInstance.slider.slideToLoop(slideIndex);
              } else {
                this.sliderInstance.slider.slideTo(slideIndex);
              }
            });
          });
        }
      }

      onReady(selectedElement) {
        if (!FoxTheme.config.motionReduced && selectedElement && this.sliderInstance) {
          const motionEls = selectedElement.querySelectorAll('motion-element');
          motionEls.forEach((motionEl) => {
            // motionEl && motionEl.refreshAnimation();
          });
        }
      }

      handleAfterInit() {
        this.removeAttribute('data-media-loading');

      }

      handleSlideChange(swiper) {
        const { slides, realIndex, activeIndex } = swiper;
        this.selectedIndex = realIndex;
      }

      attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'selected-index' && oldValue !== null && oldValue !== newValue) {
          const fromElements = this.querySelectorAll(`[data-swiper-slide-index="${oldValue}"]`);
          const toElements = this.querySelectorAll(`[data-swiper-slide-index="${newValue}"]`);

          fromElements.forEach((fromElement) => {
            const motionEls = fromElement.querySelectorAll('motion-element');
            motionEls &&
              motionEls.forEach((motionEl) => {
                if (motionEl.hasAttribute('data-text')) {
                  motionEl.resetAnimation();
                }
              });
          });

          toElements.forEach((toElement) => {
            setTimeout(() => {
              if (toElement.classList.contains('swiper-slide-active')) {
                const motionEls = toElement.querySelectorAll('motion-element');
                motionEls.forEach((motionEl) => {
                  motionEl && motionEl.refreshAnimation();
                });
              }
            });
          });
        }
      }

      calcSlideHeight() {
        let maxHeight = 0;
        const slides = this.querySelectorAll('.swiper-slide');
        slides &&
          slides.forEach((slide) => {
            const slideImage = slide.querySelector('.slideshow__slide-bg picture img, .slideshow__slide-bg .media img');
            if (slideImage) {
              const slideImageHeight = slideImage.offsetHeight;
              if (slideImageHeight > maxHeight) {
                maxHeight = slideImageHeight;
              }
            }
          });

        if (this.classList.contains('slideshow-controls-position--bottom')) {
          maxHeight += 100; // Avoid overlap with dots.
        }

        this.style.setProperty('--slide-height', `${maxHeight}px`);
      }
    }
  );
}
